export const RESET_BOOK_RESPONSE = "RESET_BOOK_RESPONSE";
export const RESET_FORM_TYPE = "RESET_FORM_TYPE";
export const SET_TPA_DETAILS = "SET_TPA_DETAILS";
export const SET_APPOINTMENT_DATE_TYPE = "SET_APPOINTMENT_DATE_TYPE";
export const SET_MOBILE_TYPE = "SET_MOBILE_TYPE";
export const SET_EMAIL_TYPE = "SET_EMAIL_TYPE";
export const SET_APPOINTMENT_TIME_TYPE = "SET_APPOINTMENT_TIME_TYPE";
export const SET_IS_MODAL_OPEN_TYPE = "SET_IS_MODAL_OPEN_TYPE";
export const SET_ERROR_TYPE = "SET_ERROR_TYPE";
export const SET_LANGUAGE_TYPE = "SET_LANGUAGE_TYPE";
export const SET_IS_INSTANT_TYPE = "SET_IS_INSTANT_TYPE";
export const SET_CALL_MODE_TYPE = "SET_CALL_MODE_TYPE";
export const SET_VH_SLOTS_TYPE = "SET_VH_SLOTS_TYPE";
export const SET_VH_MIN_DATE_TYPE = "SET_VH_MIN_DATE_TYPE";
export const SET_VH_MAX_DATE_TYPE = "SET_VH_MAX_DATE_TYPE";